import { createFileRoute } from "@tanstack/react-router";
import { ArchiveRequests } from "@/components/ArchiveRequests";

function RouteComponent() {
  return <ArchiveRequests />;
}

export const Route = createFileRoute("/_authenticated/archive-requests/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
